import { useDelete } from '@refinedev/core';

export const useDeleteCalendarMutation = () => {
  const { mutateAsync, error, isLoading } = useDelete();

  const deleteCalendar = async (id: string) => {
    return mutateAsync({
      resource: `calendars`,
      id,
    });
  };

  return {
    deleteCalendar,
    isLoading,
    error,
  };
};
